import Books from './Books';

const BooksPage = () => (
  <Books />
);

export default BooksPage;
